import { memo, useCallback, useMemo, useState } from 'react';

import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import ExpandMore from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';

import { DropdownMenu } from '../dropdownMenu/DropdownMenu';
import { useStyles } from './UserProfile.styles';
import { UserProfileProps } from './UserProfile.types';
import { hashCode } from './utils/hashCode';

export const UserProfile = memo(({ user, userProfileMenuItems }: UserProfileProps) => {
  const hashForLetter = useMemo(() => hashCode(user.first_name || ''), [user.first_name]);

  const styles = useStyles({ hashForLetter });

  const [userProfileMenuRef, setUserProfileMenuRef] = useState<null | HTMLElement>(null);

  const handleUserProfileMenuOpen = useCallback(
    (event: { currentTarget: HTMLElement }) => {
      setUserProfileMenuRef(event.currentTarget);
    },
    [setUserProfileMenuRef],
  );

  const handleUserProfileMenuClose = useCallback(() => setUserProfileMenuRef(null), [setUserProfileMenuRef]);

  return (
    <div
      id="navigation-user"
      className={clsx(styles.root, { [styles.hover]: !!userProfileMenuRef })}
      onMouseEnter={handleUserProfileMenuOpen}
      onMouseLeave={handleUserProfileMenuClose}
      onTouchEnd={handleUserProfileMenuOpen}
    >
      <Grid container alignItems="center" wrap="nowrap">
        <Grid item>
          <Avatar
            classes={{ colorDefault: styles.colorDefault }}
            className={styles.avatar}
            alt={user.first_name || ''}
            src={!!user.approved && user.imageUrl ? user.imageUrl : user.first_name}
          />
        </Grid>

        <Grid item>
          <div className={styles.expandMoreWrapper}>
            <ExpandMore className={styles.arrowDown} />
          </div>
        </Grid>
      </Grid>

      <DropdownMenu
        user={user}
        open={!!userProfileMenuRef}
        anchorEl={userProfileMenuRef}
        submenuItems={userProfileMenuItems}
        handleSubmenuClose={handleUserProfileMenuClose}
        MenuListProps={{
          onMouseLeave: () => handleUserProfileMenuClose(),
        }}
      />
    </div>
  );
});
